<template>
  <button :class="ATIButtonClass" type="button" @click="buttonClicked">
    <p v-if="!show">{{ inactive_button_text }}</p>
    <p v-else>{{ active_button_text }}</p>
  </button>
</template>

<script>
import { ref, onMounted } from 'vue';

export default {
  props: ['button_type', 'active_button_text', 'inactive_button_text',"show"],
  setup(props, { emit }) {
    const ATIButtonClass = ref("ATI-button"); // default значение класса кнопки

    onMounted(() => {
      if (props.button_type === "switch") {
        ATIButtonClass.value = "ATI-button-switch";
      }
    });

    const buttonClicked = () => {
      emit('update:show', !props.show);
    };

    return {
      ATIButtonClass,
      buttonClicked,
    };
  },
};
</script>


<style>
  .ATI-button {
    min-width: 60px;
    padding: 10px 17px;
    font-size: 16px;
    border: none;
    border-radius: 5px;
    background-color: #007BFF;
    color: white;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }

  .ATI-button:hover {
    background-color: #0056b3;
  }

  .ATI-button-switch {
    min-width: 60px;
    padding: 10px 17px;
    font-size: 16px;
    border: none;
    border-radius: 5px;
    background-color: #28a745;
    color: white;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }

  .ATI-button-switch:hover {
    background-color: #196d2c;
  }

  .ATI-button-switch-active {
    min-width: 60px;
    padding: 10px 17px;
    font-size: 16px;
    border: none;
    border-radius: 5px;
    background-color: #17a2b8;
    color: white;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }

  .ATI-button-switch-active:hover {
    background-color: #0e6572;
  }
</style>